import { Lock, Security, Settings } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { colors } from "../../../ui/colors";

type Props = {
  locked: boolean;
  onLock: () => void;
};

export const NavVault: React.FC<Props> = ({ locked, onLock }) => {
  const unlocked = !locked;

  return (
    <Box
      sx={{
      position: "sticky",
  top: 0, 
  zIndex: 10, 
  backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        width: "100%",
        height: "fit-content",
        borderBottom: `1px solid ${colors.lightGray.base}`,
        // boxShadow: "0px 1px 5px rgba(249,115,22, 0.3)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        py: 1,

      }}
    >
      <Box sx={{ width: "fit", gap: 1, px: 1, display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
        <Security sx={{ background: colors.orange.base, color: "white", borderRadius: "5px" }} />
        <Typography sx={{ fontWeight: 500 }}>Enterprise Vault</Typography>

        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 10,
            height: 18,
            background: colors.gray[100],
            fontWeight: 500,
            padding: "3px 6px",
            borderRadius: "5px",
            color: colors.orange.base,
          }}
        >
          {unlocked ? "locked" : "Unlocked"}
        </span>
      </Box>
      <Box sx={{ justifySelf: "end" }}>
        <Button
          onClick={onLock}
          disabled={unlocked}
          variant="contained"
          startIcon={<Lock />}
          sx={{
            textTransform: "none",
            backgroundColor: colors.orange.base,
            borderRadius: "8px",
            px: 2,
            boxShadow: "none",
            "&:hover": { backgroundColor: "#e56f00", boxShadow: "none" },
            "&:disabled": { opacity: 0.6, boxShadow: "none" },
          }}
        >
          Lock
        </Button>
      </Box>
    </Box>
  );
};
